import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LogoModule } from 'src/app/angie-shared/components/logo/logo.module';
import { FormlySharedModule } from 'src/app/angie-shared/modules/formly-shared.module';
import { SanitizeBypassModule } from 'src/app/angie-shared/pipes/sanitize-bypass/sanitize-bypass.module';
import { AuthWrapperComponent } from './auth-wrapper.component';

@NgModule({
	declarations: [AuthWrapperComponent],
	imports: [CommonModule, FormlySharedModule, LogoModule, TranslateModule, SanitizeBypassModule],
	exports: [AuthWrapperComponent]
})
export class AuthWrapperModule {}
